import React, { useEffect, useState } from "react";
import { Card, Col, Form, Input, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dispatch, useSelector } from "../../../redux/store";
import { openNotification } from "../../../global/item/Notification/Notification";
import Loading from "../../../global/item/Loading/loading";
import ButtonBottom from "../../../global/item/ButtonComponent/ButtonBottom";
import { getContactDetail, updateContactDetail } from "../../../redux/action/contact";

function ContactEditScreen() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { contactDetail } = useSelector((state) => state.contact);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getContactDetail());
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      await dispatch(
        updateContactDetail({
          a: {
            address: values.address,
            linkAddress: values.linkAddress,
            contact1: values.contact1,
            contact2: values.contact2,
            contact3: values.contact3,
            contact4: values.contact4,
            email: values.email,
          },
        })

      );

      openNotification({
        type: "success",
        message: t("update"),
        description: t("messUpdate"),
      });
      navigate("/contact");
    } catch (err) {
      console.error(err);
      openNotification({
        type: "error",
        message: "Lỗi",
        description: "Dữ liệu cập nhật thất bại!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          requiredMark={false}
        >
          <Card className="layoutItem">
            <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
              {t("basicInformation")}
            </h3>
            <Row gutter={[20, 0]}>
              <Col xl={24}>
                <Form.Item
                  label={"Địa chỉ"}
                  name="address"
                  initialValue={contactDetail?.address}
                  rules={[
                    { required: true, message: t("addressInfo.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập địa chỉ")} />
                </Form.Item>
              </Col>
              <Col xl={24}>
                <Form.Item
                  label={"Link maps"}
                  name="linkAddress"
                  initialValue={contactDetail?.linkAddress}
                  rules={[
                    { required: true, message: t("linkAddressInfo.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập link maps")} />
                </Form.Item>
              </Col>
               <Col xl={24}>
                <Form.Item
                  label={"Số điện thoại 1"}
                  name="contact1"
                  initialValue={contactDetail?.contact1}
                  rules={[
                    { required: true, message: t("contact1Info.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập số điện thoại 1")} />
                </Form.Item>
              </Col>
              <Col xl={24}>
                <Form.Item
                  label={"Số điện thoại 2"}
                  name="contact2"
                  initialValue={contactDetail?.contact2}
                  rules={[
                    { required: true, message: t("contact2Info.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập số điện thoại 2")} />
                </Form.Item>
              </Col>
               <Col xl={24}>
                <Form.Item
                  label={"Số điện thoại 3"}
                  name="contact3"
                  initialValue={contactDetail?.contact3}
                  rules={[
                    { required: true, message: t("contact3Info.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập số điện thoại 3")} />
                </Form.Item>
              </Col>
              <Col xl={24}>
                <Form.Item
                  label={"Số điện thoại 4"}
                  name="contact4"
                  initialValue={contactDetail?.contact4}
                  rules={[
                    { required: true, message: t("contact4Info.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập số điện thoại 4")} />
                </Form.Item>
              </Col>
             
              <Col xl={24}>
                <Form.Item
                  label={"Mail"}
                  name="email"
                  initialValue={contactDetail?.email}
                  rules={[
                    { required: true, message: t("emailInfo.message") },
                  ]}
                >
                  <Input placeholder={t("Nhập email")} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <ButtonBottom
            onContinueClick={handleSubmit}
            btnCancel={t("cancel")}
            btnContinue={t("continue")}
          />
        </Form>
      )}
    </div>
  );
}

export default ContactEditScreen;
